module.exports = __webpack_public_path__ + "img/RX-RAD-DIGI-Sala-6.28d08c09.png";